import styled from 'styled-components';
import { ReactComponent as RawCloseSVG } from '../../../../assets/icons/icon_close.svg';

export const IconClose = styled(RawCloseSVG)``;
